import React, { useRef, useState } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import EditIcon from '@material-ui/icons/Edit';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import './index.css';
import ReactAvatarEditor from 'react-avatar-editor';
import { Box, Button } from '@material-ui/core';
import HighlightOffIcon from '@material-ui/icons/HighlightOff';
interface ImageItem {
  id: string;
  index: number;
  type: string;
}

interface Position {
  x: number;
  y: number;
}
interface State {
  showDialog: boolean;
  image: string;
  scale: number;
  borderRadius: number;
  width: number;
  height: number;
  rotate: number;
  updatedImage: string;
}

const type = 'Image'; // Need to pass which type element can be draggable

const Image = ({ image, index, moveImage, removeItem, updateImage }) => {
  const ref = useRef(null);
  const [state, setState] = useState<State>({
    updatedImage: '',
    showDialog: false,
    image: '',
    scale: 1,
    borderRadius: 0,
    width: 200,
    height: 200,
    rotate: 0,
  });

  const [imageEditor, setImageEditor] = useState(null);

  const [, drop] = useDrop<ImageItem>({
    accept: type,
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Move the content
      moveImage(dragIndex, hoverIndex);
      // Update the index for dragged item directly to avoid flickering when half dragged
      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag<ImageItem, void, { isDragging: boolean }>({
    // item: { type, id: image.id, index },
    type,
    item: () => ({ id: image.id, index, type }),
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });


  // initialize drag and drop into the element
  drag(drop(ref));

  const openEditImageModal = (): void => {
    setState({ ...state, showDialog: true, image: image.src });
  };

  const closeModal = (): void => {
    setState({ ...state, showDialog: false });
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setState({ ...state, [e.target.name]: parseFloat(e.target.value) });
  };

  const setEditorRef = (editor) => {
    setImageEditor(editor);
  };

  const blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
  };

  const saveEditor = () => {
    if (imageEditor) {
      let canvas = imageEditor.getImage();
      canvas.toBlob(async (blob) => {
        await updateImage(blobToFile(blob, 'image.jpg'), index);
        setState({ ...state, showDialog: false });
      });
    }
  };
  return (
    <div
      ref={ref}
      style={{ opacity: isDragging ? 0 : 1 }}
      className='file-item'
    >
      <Box className='image-actions'>
        <EditIcon className='edit-image-icon' onClick={openEditImageModal} />
        <HighlightOffIcon
          className='remove-image-icon'
          onClick={() => removeItem(index)}
        />
      </Box>
      <img alt={`img - ${image.id}`} src={image.src} className='file-img' />
      <Dialog
        fullWidth
        open={state.showDialog}
        onClose={closeModal}
        aria-label='Create post'
        className='edit-image-dialog'
      >
        <DialogContent>
          <Box display='flex' justifyContent='center'>
            <Box maxWidth='500px'>
              <ReactAvatarEditor
                ref={setEditorRef}
                width={380}
                height={220}
                image={state.image}
                scale={state.scale}
                borderRadius={state.borderRadius}
                rotate={state.rotate}
              />
            </Box>
          </Box>
          <Box display='flex' justifyContent='center'>
            <div className='avatar-property'>Zoom: </div>
            <input
              name='scale'
              type='range'
              onChange={handleChange}
              min='0'
              max='2'
              step='0.01'
              defaultValue='1'
            />
          </Box>
          <Box
            display='flex'
            alignItems='center'
            justifyContent='center'
            marginTop='2em'
          >
            <div className='base-color'>
              <Button className='countdown-save-button' onClick={saveEditor}>
                Save
              </Button>
            </div>
          </Box>
        </DialogContent>
      </Dialog>
    </div>
  );
};

const ImageList = ({ images, moveImage, removeItem, updateImage }) => {
  const renderImage = (image, index) => {
    return (
      <Image
        updateImage={updateImage}
        image={image}
        index={index}
        key={`${image.id}-image`}
        moveImage={moveImage}
        removeItem={removeItem}
      />
    );
  };

  return <section className='file-list'>{images.map(renderImage)}</section>;
};

export default ImageList;
